// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__Sspl_","carousel-dots":"Carousel_carousel-dots__55JUu","carousel-dot":"Carousel_carousel-dot__AFP0L"};